import { xlsxTypes } from "redux/reducers/XLSX/xlsxTypes"
import { PROYECT } from "services/api"
import { setSnackbar, startRequestComp, stopRequestComp } from '../search/searchActions';
import { api_post } from 'services/api';

const {
  SET_XLSX, 
  REMOVE_XLSX, 
  CLEAN_XLSX,
  RESET_XLSX_STATE, 
  UPDATE_XLSX,
  UPDATE_XLSX_ERROR 
} = xlsxTypes

const url = `${process.env.REACT_APP_URL}${PROYECT}/xml_volumetrics`
export const setXlsxRow = (data) => {
  return {
    type: SET_XLSX,
    payload: data
  }
}


export const postXlsmFiles = (forms, close=null) => {
  return async (dispatch) => {
    try {
      dispatch(startRequestComp('loadingXlsx'))
      await Promise.all(forms.map(async (form) => {
        const formData = new FormData();
        formData.append("files", form.file, form.fileName);
        await api_post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(resp => {
          dispatch({ type: UPDATE_XLSX, payload: { id: form.id, url: resp?.url } });
        }).catch(err => {
          const message = err ? err : `Error en el archivo: ${form.fileName}`
          dispatch({ type: UPDATE_XLSX_ERROR, payload: { id: form.id, error: message } });
        })
      }));
      
      close && close();
      dispatch(stopRequestComp('loadingXlsx'))  
    } catch (error) {
      dispatch(setSnackbar('Error en el servicio'));
    }
  };
};


export const removeXlsxRow = (id) => {
  return {
    type: REMOVE_XLSX,
    payload: id
  } 
}

export const cleanXlsxList = () => {
  return {
    type: CLEAN_XLSX,
  }
}

export const resetXlsxState = () => {
  return {type: RESET_XLSX_STATE}
}